import { Component } from '@angular/core';
import { SimpleModalComponent } from 'ngx-simple-modal';
import { Constants } from '../common/constants';
import { Utils } from '../common/utils';

export interface FileViewInterface {
  fileBase64Data: string;
  fileType: string;
}
@Component({
  selector: 'app-file-view-modal',
  templateUrl: './file-view-modal.component.html',
  styleUrls: ['./file-view-modal.component.css']
})
export class FileViewModalComponent extends SimpleModalComponent<FileViewInterface, string> implements FileViewInterface {

  pdfSrc: any;
  private _fileBase64Data: string;

  get fileBase64Data(): string {
    return this._fileBase64Data;
  }
  set fileBase64Data(value: string) {
    this._fileBase64Data = value;
    if (value) {
      this.pdfSrc = { url: value, isEvalSupported: false };
    }
  }
  
  fileType: string;

  constructor(public constants: Constants, public utils: Utils) { 
    super();
  }

  closeModal() {
    this.close();
  }

}
